import Decimal from 'decimal.js-light';

export const safeDecimal = value => new Decimal(value || 0);

export const subtractPercent = (value = 0, percent = 0) => {
  const num = safeDecimal(value);
  return num.minus(num.times(percent).div(100)).toNumber();
};
